import * as PIXI from "pixi.js";
import { GameData } from "../gamestate/gameData";
import { getParameterByName } from "../../../common/getParameters";
import { createMovieClip } from "../../../common/functions/Functions_General";
import { FireWorksBuilder } from "../fireworks";
import { GameElement } from "../../../common/gameLib/BaseGame/GameElement";
import { BlinkLightArrayBuilder, expandingLight, spotLight } from "./bg_lights";
import { musicSelect } from "../../../common/functions/Function_settingsPage";

export class Environment extends GameElement<GameData> {
  private enableBGanimation: boolean;
  private backGroundCenter: PIXI.Sprite;
  private backGroundLeft: PIXI.Sprite;
  private backGroundRight: PIXI.Sprite;
  private maxParticlesPerSide: number;
  private leftParticles: Array<PIXI.Sprite>;
  private leftParticlesTween: Array<PIXI.tween.Tween>;
  private rightParticles: Array<PIXI.Sprite>;
  private rightParticlesTween: Array<PIXI.tween.Tween>;
  // private tissueA: PIXI.extras.AnimatedSprite;
  // private tissueB: PIXI.extras.AnimatedSprite;
  private firework: FireWorksBuilder;
  private demoRibbon: PIXI.Sprite;
  private demoText: PIXI.Text;
  private textDesign: PIXI.TextStyle;
  // private activeGameData: GameData;
  // private parent: PIXI.Container;
  private parentContainer: PIXI.Container;
  private gameBGUI: PIXI.Sprite;
  // private leftEyeFire: PIXI.extras.AnimatedSprite;
  // private rigthtEyeFire: PIXI.extras.AnimatedSprite;
  private glowR: PIXI.Sprite;
  private glowL: PIXI.Sprite;

  private textureNight1: PIXI.Texture;
  private textureNight2: PIXI.Texture;
  private textureNight3: PIXI.Texture;
  private textureDay1: PIXI.Texture;
  private textureDay2: PIXI.Texture;
  private textureDay3: PIXI.Texture;
  private bgChristmasTreePortrait: PIXI.Sprite;
  private bgChristmasTreePortraitTexture1: PIXI.Texture;
  private bgChristmasTreePortraitTexture2: PIXI.Texture;
  private bgChristmasTreePortraitGradTexture1: PIXI.Texture;
  private bgChristmasTreePortraitGradTexture2: PIXI.Texture;
  private backgroundLightsContainer: PIXI.Container;

  private movingLights: Array<spotLight>;
  private blinkingLights: Array<BlinkLightArrayBuilder>;
  private soundFxSpeaker: Array<PIXI.extras.AnimatedSprite>;

  private portraitBlinkingTop: BlinkLightArrayBuilder;
  private portraitBlinkingBot: BlinkLightArrayBuilder;
  private ExpandingLightL: expandingLight;

  private ExpandingLightR: expandingLight;

  private ExpandingLightPortrait: expandingLight;
  private fx_absorbtionStar: Array<PIXI.Sprite>;
  private fx_absorbtionTweenStar: Array<PIXI.tween.Tween>;
  private clipSergioR: PIXI.extras.AnimatedSprite;
  private clipSergioL: PIXI.extras.AnimatedSprite;

  constructor(activeGameData: GameData, parent: PIXI.Container) {
    super(activeGameData, parent);

    this.activeGameData = activeGameData;
    this.enableBGanimation = true; //<--------------ControlsBganimation
    this.parentContainer = parent;
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    this.backgroundLightsContainer = new PIXI.Container();
    this.parent.addChild(this.backgroundLightsContainer);

    this.bgChristmasTreePortraitGradTexture1 = PIXI.Texture.fromImage(
      // "game_BG.png"
      //  "mobileBG0.png"
      "gradientBaseGame.png"
    );
    this.bgChristmasTreePortraitGradTexture2 = PIXI.Texture.fromImage(
      "gradientBonusGame.png"
      // "mobileBG0.png"
    );

    this.bgChristmasTreePortraitTexture1 = PIXI.Texture.fromImage(
      "mobileBG0.png"
    );
    this.bgChristmasTreePortraitTexture2 = PIXI.Texture.fromImage(
      "mobileBG.png"
    );

    this.textureNight1 = PIXI.Texture.fromImage("backgroundStage.png");
    this.textureNight2 = PIXI.Texture.fromImage("backgroundStage.png");
    this.textureNight3 = PIXI.Texture.fromImage("backgroundStage.png");
    this.textureDay1 = PIXI.Texture.fromImage("backgroundStage.png");
    this.textureDay2 = PIXI.Texture.fromImage("backgroundStage.png");
    this.textureDay3 = PIXI.Texture.fromImage("backgroundStage.png");

    this.backGroundCenter = new PIXI.Sprite(this.textureDay1);
    this.backGroundCenter.scale.set(1 / 0.96);
    this.backGroundCenter.anchor.set(0.5, 0);
    this.backGroundCenter.position.set(this.activeGameData.size[0] / 2, 0);
    this.parent.addChild(this.backGroundCenter);
    this.backGroundCenter.alpha = 1;

    this.backGroundLeft = new PIXI.Sprite(this.textureDay2);
    this.backGroundLeft.scale.set(1 / 0.96);
    this.backGroundLeft.anchor.set(1, 0);
    this.backGroundLeft.position.set(-25, 0);
    // this.parent.addChild(this.backGroundLeft);
    // this.backGroundLeft.alpha = .5

    this.backGroundRight = new PIXI.Sprite(this.textureDay3);
    this.backGroundRight.scale.set(1 / 0.96);
    this.backGroundRight.anchor.set(0);
    this.backGroundRight.position.set(this.activeGameData.size[0] + 25, 0);
    // this.parent.addChild(this.backGroundRight);

    this.glowR = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    this.glowR.tint = 0x0000ff;
    this.glowR.scale.set(8);
    this.glowR.anchor.set(0.5);
    this.glowR.x = 150;
    this.glowR.y = this.activeGameData.size[1];

    this.glowL = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    this.glowL.scale.set(8);
    this.glowL.anchor.set(0.5);
    this.glowL.tint = 0x0000ff;
    this.glowL.x = this.activeGameData.size[0] - 150;
    this.glowL.y = this.activeGameData.size[1];
    this.glowL.alpha = 0.65;
    this.glowR.alpha = 0.65;

    this.glowR.blendMode = PIXI.BLEND_MODES.SCREEN;
    this.glowL.blendMode = PIXI.BLEND_MODES.SCREEN;

    this.leftParticles = [];
    this.leftParticlesTween = [];
    this.maxParticlesPerSide = 10;
    this.rightParticles = [];
    this.rightParticlesTween = [];
    this.createParticles();

    this.parent.addChild(this.glowL);
    this.parent.addChild(this.glowR);

    //-create insects around light
    let totInsecect = 8;
    let ins = [];
    let ins_R = [];
    for (let i = 0; i < totInsecect; i++) {
      ins[i] = createMovieClip("insect", 0, 500);
      ins[i].loop = true;
      // ins[i].tint=0x88ccaa;
      ins[i].scale.set(0.5);
      ins[i].rotation = (Math.random() * 360 * Math.PI) / 180;
      ins[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      ins[i].gotoAndPlay(Math.floor(Math.random() * 500));
      this.parent.addChild(ins[i]);
      ins[i].x = 100;
      ins[i].y = 400;

      ins_R[i] = createMovieClip("insect", 0, 500);
      ins_R[i].loop = true;
      // ins[i].tint=0x88ccaa;
      ins_R[i].scale.set(0.5);
      ins_R[i].rotation = (Math.random() * 360 * Math.PI) / 180;
      ins_R[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      ins_R[i].gotoAndPlay(Math.floor(Math.random() * 500));
      this.parent.addChild(ins_R[i]);
      ins_R[i].x = this.activeGameData.size[0] - 100;
      ins_R[i].y = 400;
    }

    this.firework = new FireWorksBuilder(this.parent, this.activeGameData);
    // this.fireworkR = new FireWorksBuilder(this.parent, this.activeGameData);
    this.textDesign = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fill: "#ea9d58",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: 150,
    });

    if (getParameterByName("mode").toLowerCase() == "demo") {
      this.demoRibbon = new PIXI.Sprite(PIXI.Texture.fromImage("demoBG.png"));
      parent.addChild(this.demoRibbon);

      this.demoText = new PIXI.Text(
        this.activeGameData.gameTextGeneral.demo,
        this.textDesign
      );
      this.demoRibbon.addChild(this.demoText);

      this.demoText.anchor.set(0.5);
      this.demoText.x = this.demoRibbon.width / 2;
      this.demoText.y = this.demoRibbon.height / 2;
      this.demoText.width = this.demoRibbon.width - 25;

      this.demoRibbon.x = 12;
      this.demoRibbon.y = 0;

      if (this.activeGameData.isMobile) {
        this.demoRibbon.x = 0;
        this.demoRibbon.y = 125;
        this.demoRibbon.scale.set(0.8);
      }
    }
    this.createAbsorbtion();
    this.startAbsorbAnimation(true);

    this.createHouseBG();

    if (activeGameData.isMobile && this.activeGameData.playOnPortrait) {
      this.setPortraitBG();
    }

    this.createLights();
    this.isNight(false);
  }

  private createLights = (): void => {
    let lightp1 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    // lightp1.tint=0xff00ff;
    lightp1.alpha = 0.25;
    lightp1.blendMode = PIXI.BLEND_MODES.ADD;
    lightp1.anchor.set(1);
    lightp1.y = lightp1.height;
    lightp1.x = 300;
    this.backgroundLightsContainer.addChild(lightp1);

    let lightp2 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    lightp2.alpha = lightp1.alpha;
    lightp2.blendMode = PIXI.BLEND_MODES.ADD;
    lightp2.anchor.set(1);
    lightp2.y = lightp1.height;
    lightp2.scale.y = -1;
    lightp2.x = 300;
    this.backgroundLightsContainer.addChild(lightp2);

    let lightp3 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    lightp3.blendMode = PIXI.BLEND_MODES.ADD;
    lightp3.alpha = lightp1.alpha;
    lightp3.anchor.set(1);
    lightp3.y = lightp1.height;
    lightp3.x = this.activeGameData.size[0] - lightp1.x;
    lightp3.scale.x = -1;
    this.backgroundLightsContainer.addChild(lightp3);

    let lightp4 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    lightp4.blendMode = PIXI.BLEND_MODES.ADD;
    lightp4.alpha = lightp1.alpha;
    lightp4.anchor.set(1);
    lightp4.y = lightp1.height;
    lightp4.x = this.activeGameData.size[0] - lightp1.x;
    lightp4.scale.y = -1;
    lightp4.scale.x = -1;
    this.backgroundLightsContainer.addChild(lightp4);

    this.movingLights = [];
    this.blinkingLights = [];
    this.soundFxSpeaker = [];
    //

    let parent: PIXI.Container = this.activeGameData.gameScene;
    this.movingLights[0] = new spotLight(parent);
    this.movingLights[0].setPositin([150, -100]);
    this.movingLights[0].setTintIndex(12);

    this.movingLights[1] = new spotLight(parent);
    // this.movingLights[1].enableRandomColorsLight(true);
    this.movingLights[1].setPositin([this.activeGameData.size[0] - 150, -100]);
    // this.movingLights[1].setLightScale(2);
    this.movingLights[1].flipAnimation(true);
    this.movingLights[1].setTintIndex(12);

    this.movingLights[2] = new spotLight(parent);
    // this.movingLights[2].enableRandomColorsLight(true);
    this.movingLights[2].setPositin([0, this.activeGameData.size[1] + 150]);
    this.movingLights[2].setLightPointingAngleInDegree(180);
    this.movingLights[2].setLightScale(1.5);
    this.movingLights[2].setLightMaxRotatePerSideAngleInDegree(50);
    this.movingLights[2].getAnimationTween().time = 4000;
    // this.movingLights[2].setLightMaxRotatePerSideAngleInDegree(50);
    this.movingLights[2].setTintIndex(12);

    this.movingLights[3] = new spotLight(parent);
    // this.movingLights[3].enableRandomColorsLight(true);
    this.movingLights[3].setPositin([
      this.activeGameData.size[0],
      this.activeGameData.size[1] + 150,
    ]);
    this.movingLights[3].setLightPointingAngleInDegree(180);
    this.movingLights[3].setLightScale(1.5);
    this.movingLights[3].getAnimationTween().time = 4000;
    this.movingLights[3].setLightMaxRotatePerSideAngleInDegree(50);
    this.movingLights[3].flipAnimation(true);
    this.movingLights[3].setTintIndex(12);

    //---

    let pos = [257, 152];
    let horizontalCount = 22;
    let verticalCount = 10;
    let offset =
      (this.activeGameData.size[0] - pos[0] * 2) / (horizontalCount - 1);

    //-- test
    //-left side of blinking lights
    this.blinkingLights[0];
    this.blinkingLights[0] = new BlinkLightArrayBuilder(
      this.parent,
      verticalCount,
      false,
      offset
    );
    this.blinkingLights[0].setPosition(pos);
    //-right side of blinking lights
    this.blinkingLights[1] = new BlinkLightArrayBuilder(
      this.parent,
      verticalCount,
      false,
      offset
    );
    this.blinkingLights[1].setPosition([
      this.activeGameData.size[0] - pos[0],
      pos[1],
    ]);
    //-top side of blinking lights
    this.blinkingLights[2] = new BlinkLightArrayBuilder(
      this.parent,
      horizontalCount,
      true,
      offset
    );
    this.blinkingLights[2].setPosition([pos[0], pos[1] - offset]);
    this.blinkingLights[2].hideSelected([9, 10, 11, 12]);

    // lightWhite.png

    // this.backgroundLightsContainer
    this.ExpandingLightL = new expandingLight(
      this.backgroundLightsContainer,
      false
    );

    this.ExpandingLightR = new expandingLight(
      this.backgroundLightsContainer,
      true
    );

    //--------------

    this.soundFxSpeaker[0] = createMovieClip("ShockWave", 0, 25);
    this.parent.addChild(this.soundFxSpeaker[0]);
    this.soundFxSpeaker[0].loop = false;
    this.soundFxSpeaker[0].position.set(110, 845);
    // this.soundFxSpeaker[0].gotoAndPlay(0);
    this.soundFxSpeaker[0].anchor.set(0.5);
    this.soundFxSpeaker[0].scale.set(4);
    this.soundFxSpeaker[0].alpha = 0.1;
    this.soundFxSpeaker[0].animationSpeed = 0.4;

    this.soundFxSpeaker[1] = createMovieClip("ShockWave", 0, 25);
    this.parent.addChild(this.soundFxSpeaker[1]);
    this.soundFxSpeaker[1].loop = false;
    this.soundFxSpeaker[1].position.set(110, 737);
    //  this.soundFxSpeaker[1].gotoAndPlay(0);
    this.soundFxSpeaker[1].anchor.set(0.5);
    this.soundFxSpeaker[1].scale.set(4);
    this.soundFxSpeaker[1].alpha = 0.1;
    this.soundFxSpeaker[1].animationSpeed = 0.4;
    this.soundFxSpeaker[1].blendMode = PIXI.BLEND_MODES.SCREEN_NPM;

    this.soundFxSpeaker[2] = createMovieClip("ShockWave", 0, 25);
    this.parent.addChild(this.soundFxSpeaker[2]);
    this.soundFxSpeaker[2].loop = false;
    this.soundFxSpeaker[2].position.set(this.activeGameData.size[0] - 110, 845);
    //  this.soundFxSpeaker[2].gotoAndPlay(0);
    this.soundFxSpeaker[2].anchor.set(0.5);
    this.soundFxSpeaker[2].scale.set(4);
    this.soundFxSpeaker[2].alpha = 0.1;
    this.soundFxSpeaker[2].animationSpeed = 0.4;

    this.soundFxSpeaker[3] = createMovieClip("ShockWave", 0, 25);
    this.parent.addChild(this.soundFxSpeaker[3]);
    this.soundFxSpeaker[3].loop = false;
    this.soundFxSpeaker[3].position.set(this.activeGameData.size[0] - 110, 737);
    //  this.soundFxSpeaker[3].gotoAndPlay(0);
    this.soundFxSpeaker[3].anchor.set(0.5);
    this.soundFxSpeaker[3].scale.set(4);
    this.soundFxSpeaker[3].alpha = 0.1;
    this.soundFxSpeaker[3].animationSpeed = 0.4;
  };

  private enableMovingLight = (bool: boolean): void => {
    for (let i = 0; i < this.movingLights.length; i++) {
      this.movingLights[i].setVisible(bool);
    }
    for (let i = 0; i < this.blinkingLights.length; i++) {
      this.blinkingLights[i].setVisible(bool);
    }

    if (this.activeGameData.isMobile && this.activeGameData.playOnPortrait) {
      this.portraitBlinkingTop.setVisible(bool);
      this.portraitBlinkingBot.setVisible(bool);
    }
  };
  // private enableSoundFx=()

  public playSpeakerFx = (): void => {
    for (let i = 0; i < this.soundFxSpeaker.length; i++) {
      this.soundFxSpeaker[i].gotoAndPlay(0);
    }
  };

  public isNight = (bool: boolean): void => {
    // console.log(this.activeGameData.GameContext().bonus ,this.activeGameData.GameContext().finished)
    this.ExpandingLightR.setLightOn(bool);
    this.ExpandingLightL.setLightOn(bool);
    this.enableMovingLight(bool);
    // this.startAbsorbAnimation(bool);
    // this.backgroundLightsContainer.alpha=bool?1:0;

    if (bool) {
      this.backGroundCenter.texture = this.textureNight1;
      this.backGroundLeft.texture = this.textureNight2;
      this.backGroundRight.texture = this.textureNight3;

      this.activeGameData.mainGame.setBonusLeftVisible(true);
      this.activeGameData.background.setNewTexture("gradientBonusGame.png"); //sky desktop

      if (this.activeGameData.isMobile && this.activeGameData.playOnPortrait) {
        this.bgChristmasTreePortrait.texture = this.bgChristmasTreePortraitTexture2;
        this.activeGameData.portraitBGSky.texture = this.bgChristmasTreePortraitGradTexture2;

        this.ExpandingLightPortrait.setLightOn(true);
      }

      // //  this.activeGameData.bonusGameMusic.stop();
      // if (this.activeGameData.bonusGameMusic.playing() == false) {
      //   this.activeGameData.bonusGameMusic.play("bonus");
      //   this.activeGameData.normalGameMusic.stop();
      // }
      musicSelect(1, this.activeGameData);

      this.activeGameData.mainGame.setBonusLeftVisible(true);
      this.clipSergioR.gotoAndPlay(0);
      this.clipSergioL.gotoAndPlay(0);
      this.clipSergioL.tint = 0xffffff;
      this.clipSergioR.tint = 0xffffff;
    } else {
      this.activeGameData.mainGame.setBonusLeftVisible(false);
      this.backGroundCenter.texture = this.textureDay1;
      this.backGroundLeft.texture = this.textureDay2;
      this.backGroundRight.texture = this.textureDay3;
      this.activeGameData.background.setNewTexture("gradientBaseGame.png");

      if (this.activeGameData.isMobile && this.activeGameData.playOnPortrait) {
        this.bgChristmasTreePortrait.texture = this.bgChristmasTreePortraitTexture1;
        this.activeGameData.portraitBGSky.texture = this.bgChristmasTreePortraitGradTexture1;
        this.ExpandingLightPortrait.setLightOn(false);
      }

      // default gam

      // if (this.activeGameData.normalGameMusic.playing() == false) {
      //   this.activeGameData.normalGameMusic.stop();
      //  this.activeGameData.normalGameMusic.play("music");
      //   this.activeGameData.bonusGameMusic.stop();
      //   // console.log("play")
      // }

      musicSelect(0, this.activeGameData);

      this.activeGameData.mainGame.setBonusLeftVisible(false);
      this.clipSergioR.gotoAndStop(0);
      this.clipSergioL.gotoAndStop(0);
      this.clipSergioL.tint = 0x10ffff;
      this.clipSergioR.tint = 0x10ffff;
    }
  };
  public checkMusicAndBonusMode = (): void => {
    if (
      // (this.activeGameData.GameContext().bonusGameResult != undefined &&
      //   this.activeGameData.GameContext().finished == false) ||
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.GameContext().finished == false
    ) {
      //--bonus game
      if (this.activeGameData.bonusGameMusic.playing() == false) {
        //   console.log("BONUS MUSIC========================")
        // console.log("NIGHT FIX1ss");
        this.isNight(true);
      }
    } else {
      //-normal gae
      this.isNight(false);
    }
  };

  public checkBonusMusic = (): void => {
    let hasBonusSpins =
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins > 0;
    let hasBonusResult =
      this.activeGameData.GameContext().bonusGameResult != undefined &&
      this.activeGameData.GameContext().bonus;
    // console.log("NIGHT FIX1");
    if (hasBonusResult || hasBonusSpins) {
      //--bonus game

      this.isNight(true);
    } else {
      this.isNight(false);
    }
  };

  private setPortraitBG = (): void => {
    let topContainer = this.activeGameData.portraitModeBackground.getTopContainer();

    let botContainer = this.activeGameData.portraitModeBackground.getBotContainer();
    let maxWidth = this.activeGameData.size[0];

    //create lights
    let lightp1 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    // lightp1.tint=0xff00ff;
    lightp1.alpha = 0.25;
    lightp1.blendMode = PIXI.BLEND_MODES.ADD;
    lightp1.scale.set(2);
    lightp1.anchor.set(1);
    lightp1.y = -1080;
    lightp1.rotation = Math.PI / 2;
    lightp1.x = this.activeGameData.size[0] / 2;
    botContainer.addChild(lightp1);
    let lightp2 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    // lightp1.tint=0xff00ff;
    lightp2.alpha = 0.25;
    lightp2.blendMode = PIXI.BLEND_MODES.ADD;
    lightp2.scale.set(2, -2);
    lightp2.anchor.set(1);
    lightp2.y = -1080;
    lightp2.rotation = Math.PI / 2;
    lightp2.x = this.activeGameData.size[0] / 2;
    botContainer.addChild(lightp2);

    let lightReelTop = new PIXI.Sprite(PIXI.Texture.fromFrame("lightReel.png"));
    lightReelTop.width = this.activeGameData.size[0];
    lightReelTop.y = 320;
    lightReelTop.scale.y = lightReelTop.scale.x;
    topContainer.addChild(lightReelTop);
    let lightReelBot = new PIXI.Sprite(PIXI.Texture.fromFrame("lightReel.png"));
    lightReelBot.width = this.activeGameData.size[0];
    lightReelBot.y = 1550;
    lightReelBot.scale.y = lightReelBot.scale.x;
    topContainer.addChild(lightReelBot);

    this.portraitBlinkingTop = new BlinkLightArrayBuilder(
      topContainer,
      19,
      true,
      50
    );
    this.portraitBlinkingTop.setPosition([60, lightReelBot.y + 40]);
    this.portraitBlinkingTop.setScale(2);
    this.portraitBlinkingTop.setVisible(true);

    this.portraitBlinkingBot = new BlinkLightArrayBuilder(
      topContainer,
      19,
      true,
      50
    );
    this.portraitBlinkingBot.setPosition([60, lightReelTop.y + 40]);
    this.portraitBlinkingBot.setScale(2);
    this.portraitBlinkingBot.setVisible(true);

    this.ExpandingLightPortrait = new expandingLight(botContainer, true);
    this.ExpandingLightPortrait.getparent().scale.set(1.5);
    this.ExpandingLightPortrait.setPosition(
      this.activeGameData.size[0] / 2,
      -500
    );
    this.ExpandingLightPortrait.setRotation(90);
    this.ExpandingLightPortrait.setLightOn(false);

    // create foregroudn

    this.bgChristmasTreePortrait = new PIXI.Sprite(
      this.bgChristmasTreePortraitTexture1
    );

    this.bgChristmasTreePortrait.anchor.set(0.5, 1);
    botContainer.addChild(this.bgChristmasTreePortrait);
    this.bgChristmasTreePortrait.x = this.activeGameData.size[0] / 2;
    this.bgChristmasTreePortrait.scale.set(2.7);
    this.bgChristmasTreePortrait.y = 0;
    this.bgChristmasTreePortrait.alpha = 1;

    let glowR = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    glowR.scale.set(20);
    glowR.anchor.set(0.5);
    glowR.x = maxWidth / 2;
    glowR.y = 0; // this.activeGameData.size[1];
    glowR.blendMode = PIXI.BLEND_MODES.SCREEN;
    glowR.alpha = 0.5;
    botContainer.addChild(glowR);

    let glowTop = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    glowTop.scale.set(15);
    glowTop.anchor.set(0.5);
    glowTop.x = maxWidth / 2;
    glowTop.y = 900; // this.activeGameData.size[1];
    // glowTop.tint=0x00ffff;
    glowTop.blendMode = PIXI.BLEND_MODES.SCREEN;
    // glowTop.tint=0x0000ff;
    glowTop.alpha = 0.5;
    topContainer.addChild(glowTop);
  };

  public setFireWorks = (bool: boolean): void => {
    let fireworks = this.firework.getFireWorks();
    let fireWorksLeft = fireworks[0];
    let fireWorksRight = fireworks[1];

    for (let index = 0; index < fireWorksLeft.length; index++) {
      fireWorksLeft[index].setEnable(bool); // bool;
      fireWorksRight[index].setEnable(bool); // = bool;
    }
    this.firework.setOn(bool);
    // this.fireworkR.setOn(bool);
  };

  private createHouseBG = (): void => {
    this.gameBGUI = new PIXI.Sprite(
      PIXI.Texture.fromImage("reelBG_desktop.png")
    );

    this.parentContainer.addChild(this.gameBGUI);

    this.gameBGUI.scale.set(1.035, 1.025);
    this.gameBGUI.anchor.set(0.5);
    this.gameBGUI.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2 - 14
    );

    this.clipSergioR = createMovieClip("sergioTv", 0, 24);
    this.parentContainer.addChild(this.clipSergioR);

    this.clipSergioR.scale.set(-1.035, 1.025);
    this.clipSergioR.anchor.set(0.5);
    this.clipSergioR.position.set(
      this.activeGameData.size[0] / 2 + 5,
      this.activeGameData.size[1] / 2 + 20
    );
    this.clipSergioR.loop = true;

    this.clipSergioL = createMovieClip("sergioTv", 0, 24);
    this.parentContainer.addChild(this.clipSergioL);

    this.clipSergioL.scale.set(1.035, 1.025);
    this.clipSergioL.anchor.set(0.5);
    this.clipSergioL.position.set(
      this.activeGameData.size[0] / 2 - 5,
      this.activeGameData.size[1] / 2 + 20
    );
    this.clipSergioL.loop = true;

    //--create lines

    let lines = [];
    for (let i = 0; i < 4; i++) {
      lines[i] = new PIXI.Sprite(PIXI.Texture.fromImage("separateLine.png"));
      lines[i].anchor.set(0.5);
      lines[i].scale.x = 0.5;
      // lines[i].x=-384+i*257.2;
      lines[i].x = -385 + i * 257.2;
      // lines[i].x=i*266-266/2
      lines[i].blendMode = PIXI.BLEND_MODES.DIFFERENCE;
      this.gameBGUI.addChild(lines[i]);
    }

    //--create side decoration

    //--create side decoration
    // let sidescale = 0.7;
    // let offsetX = 740;
    // let leftdeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe2.png"));

    // leftdeco.scale.set(sidescale, sidescale);
    // leftdeco.anchor.set(0.5);
    // leftdeco.position.set(
    //   this.activeGameData.size[0] / 2 - offsetX,
    //   this.activeGameData.size[1] / 2 - 14 + 5
    // );
    // this.parentContainer.addChild(leftdeco);

    // let rightdeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe2.png"));
    // rightdeco.scale.set(-leftdeco.scale.x, leftdeco.scale.y);

    // rightdeco.anchor.set(0.5);
    // rightdeco.position.set(
    //   this.activeGameData.size[0] / 2 + offsetX,
    //   leftdeco.y
    // );
    // this.parentContainer.addChild(rightdeco);

    // let botDeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe.png"));
    // botDeco.scale.set(1.25);
    // botDeco.rotation = (Math.PI / 2) * 3;
    // botDeco.anchor.set(0.5);
    // botDeco.position.set(this.activeGameData.size[0] / 2, 1050 + 5);
    // // this.parentContainer.addChild(botDeco);

    // let topDeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe.png"));
    // topDeco.scale.set(1.25);
    // topDeco.rotation = Math.PI / 2;
    // topDeco.anchor.set(0.5);
    // topDeco.position.set(this.activeGameData.size[0] / 2, 0);

    // let topDeco2 = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe2.png"));
    // topDeco2.scale.set(1.1);
    // topDeco2.rotation = Math.PI / 2;
    // topDeco2.anchor.set(0.5);
    // topDeco2.position.set(this.activeGameData.size[0] / 2, 50);

    // this.parentContainer.addChild(topDeco2);
    // this.parentContainer.addChild(topDeco);

    let maskLeft = new PIXI.Graphics();
    maskLeft.beginFill(0xff0000);
    maskLeft.drawRect(0, 0, 1920, 845);
    maskLeft.endFill();
    maskLeft.y = 105;
    maskLeft.x = 0;
    maskLeft.alpha = 0.5;
    // leftdeco.mask = maskLeft;
    // rightdeco.mask = maskLeft;
    // this.parentContainer.addChild(maskLeft);

    // this.parentContainer.addChild(this.gameBGUI);

    // let texturename = "drop_black.png";
    // // drop shadow
    // let dropBlack = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlack.anchor.set(0.5);
    // dropBlack.scale.set(1);
    // dropBlack.y = -25;
    // leftdeco.addChild(dropBlack);

    // let dropBlackR = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlackR.anchor.set(0.5);
    // dropBlackR.scale.set(dropBlack.scale.x);
    // dropBlackR.y = dropBlack.y;
    // rightdeco.addChild(dropBlackR);

    // // drop shadow
    // let dropBlack2 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlack2.anchor.set(0.5);
    // dropBlack2.scale.set(dropBlack.scale.x);
    // dropBlack2.y = dropBlack.y + 380;
    // leftdeco.addChild(dropBlack2);

    // let dropBlackR2 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlackR2.anchor.set(0.5);
    // dropBlackR2.scale.set(dropBlack.scale.x);
    // dropBlackR2.y = dropBlack2.y;
    // rightdeco.addChild(dropBlackR2);

    // // drop shadow
    // let dropBlack3 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlack3.anchor.set(0.5);
    // dropBlack3.scale.set(dropBlack.scale.x);
    // dropBlack3.y = dropBlack.y - 380;
    // leftdeco.addChild(dropBlack3);

    // let dropBlackR3 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlackR3.anchor.set(0.5);
    // dropBlackR3.scale.set(dropBlack.scale.x);
    // dropBlackR3.y = dropBlack3.y;
    // rightdeco.addChild(dropBlackR3);

    // if (this.activeGameData.isMobile) {
    //   this.gameBGUI.position.set(
    //     this.activeGameData.size[0] / 2,
    //     this.activeGameData.size[1] / 2 - 14 - 5
    //   );
    //   botDeco.position.set(this.activeGameData.size[0] / 2, 1050);
    //   topDeco.position.set(this.activeGameData.size[0] / 2, -7);
    // }
  };

  private createParticles = (): void => {
    if (this.activeGameData.isMobile === false) {
      for (var i = 0; i < this.maxParticlesPerSide; i++) {
        //particles on left corner
        this.leftParticles[i] = new PIXI.Sprite(
          PIXI.Texture.fromImage("snowParticles.png")
        );
        this.leftParticles[i].anchor.set(0.5);
        // this.leftParticles[i].tint = 0x0088ff;
        this.leftParticles[i].x = -0;
        // this.leftParticles[i].scale.set(2);
        this.leftParticles[i].y = -this.leftParticles[i].height * 0.75;
        this.leftParticles[i].rotation = (360 * Math.random() * Math.PI) / 180;
        // this.parent.addChild(this.leftParticles[i]);
        this.leftParticles[i].alpha = 0;

        this.leftParticlesTween[i] = PIXI.tweenManager.createTween(
          this.leftParticles[i]
        );
        this.leftParticlesTween[i]
          .from({
            x: this.leftParticles[i].x,
            y: this.leftParticles[i].y,
            alpha: 1,
            rotation: this.leftParticles[i].rotation,
          })
          .to({
            x: this.leftParticles[i].x + (Math.random() * 500 - 250),
            y: this.leftParticles[i].y + 1080,
            alpha: 0,
            rotation:
              this.leftParticles[i].rotation + (Math.random() * Math.PI) / 4,
          });
        this.leftParticlesTween[i].time = 3000;
        this.leftParticlesTween[i].delay =
          (i * this.leftParticlesTween[i].time) / this.maxParticlesPerSide;
        this.leftParticlesTween[i].time =
          Math.random() * 3000 + 15000 + i * 1000;

        // console.log(this.leftParticlesTween[i].time )
        this.leftParticlesTween[i].loop = true;
        this.leftParticlesTween[i].easing = PIXI.tween.Easing.linear();

        //particles on right corner
        this.rightParticles[i] = new PIXI.Sprite(
          PIXI.Texture.fromImage("snowParticles.png")
        );
        this.rightParticles[i].anchor.set(0.5);
        this.rightParticles[i].x = this.activeGameData.size[0];
        this.rightParticles[i].y = -this.leftParticles[i].height * 0.75;
        this.rightParticles[i].rotation = (360 * Math.random() * Math.PI) / 180;
        // this.parent.addChild(this.rightParticles[i]);
        this.rightParticles[i].alpha = 0;

        this.rightParticlesTween[i] = PIXI.tweenManager.createTween(
          this.rightParticles[i]
        );
        this.rightParticlesTween[i]
          .from({
            x: this.rightParticles[i].x,
            y: this.rightParticles[i].y,
            alpha: 1,
            rotation: this.rightParticles[i].rotation,
          })
          .to({
            x: this.rightParticles[i].x + (Math.random() * 500 - 250),
            y: this.rightParticles[i].y + 1080,
            alpha: 0,
            rotation:
              this.rightParticles[i].rotation + (Math.random() * Math.PI) / 4,
          });
        this.rightParticlesTween[i].time = 3000;
        this.rightParticlesTween[i].delay =
          (i * this.rightParticlesTween[i].time) / this.maxParticlesPerSide;
        this.rightParticlesTween[i].time =
          Math.random() * 3000 + 15000 + i * 1000;
        this.rightParticlesTween[i].loop = true;
        this.rightParticlesTween[i].easing = PIXI.tween.Easing.linear();

        this.leftParticles[i].blendMode = PIXI.BLEND_MODES.SCREEN;
        this.rightParticles[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      }

      // console.log("particles created")
      this.animateParticles();
    }
  };

  private animateParticles = (): void => {
    if (this.enableBGanimation) {
      for (var i = 0; i < this.maxParticlesPerSide; i++) {
        this.leftParticlesTween[i].start();
        this.rightParticlesTween[i].start();
      }
    } else {
      for (var i = 0; i < this.maxParticlesPerSide; i++) {
        this.leftParticlesTween[i].stop();
        this.rightParticlesTween[i].stop();
      }
    }
  };

  private startAbsorbAnimation = (bool: boolean): void => {
    for (let index = 0; index < this.fx_absorbtionStar.length; index++) {
      if (bool) {
        this.fx_absorbtionTweenStar[index].reset();
        // this.fx_absorbtionTweenStar[0].start();
      } else {
        this.fx_absorbtionTweenStar[index].stop();
        this.fx_absorbtionTweenStar[index].reset();
        this.fx_absorbtionStar[index].alpha = 0;
      }
    }
    if (bool) {
      this.fx_absorbtionTweenStar[0].start();
    }
  };

  private createAbsorbtion = (): void => {
    // 	let speedCloud=15000;
    let speedStars = 15000;
    //     let maxFxCount=2;
    let maxFxCountStars = 20;

    this.fx_absorbtionStar = [];
    this.fx_absorbtionTweenStar = [];

    let starCloudSprite = ["cloudpuff.png"];
    starCloudSprite;
    for (let i = 0; i < maxFxCountStars; i++) {
      let randomIndex = Math.floor(Math.random() * starCloudSprite.length);
      this.fx_absorbtionStar[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame(starCloudSprite[randomIndex])
      );
      this.fx_absorbtionStar[i].anchor.set(0.5);
      this.fx_absorbtionStar[i].rotation =
        (Math.random() * 360 * Math.PI) / 180;
      if (i % 2) {
        this.fx_absorbtionStar[i].position.set(
          300,
          this.activeGameData.size[1]
        );
      } else {
        this.fx_absorbtionStar[i].position.set(
          this.activeGameData.size[0] - 300,
          this.activeGameData.size[1]
        );
      }

      // this.backgroundLightsContainer.addChild(this.fx_absorbtionStar[i]);

      this.fx_absorbtionStar[i].blendMode = PIXI.BLEND_MODES.ADD;
      // this.fx_absorbtionStar[i].rotation=(Math.random()*360)*Math.PI/180;

      this.fx_absorbtionStar[i].anchor.set(0.5);
      this.fx_absorbtionStar[i].alpha = 0;
      this.fx_absorbtionTweenStar[i] = PIXI.tweenManager.createTween(
        this.fx_absorbtionStar[i]
      );
      this.fx_absorbtionTweenStar[i]
        .from({ scale: { x: 0, y: 0 }, alpha: 1 })
        .to({ scale: { x: 10, y: 10 }, alpha: 0 });
      this.fx_absorbtionTweenStar[i].time = speedStars;
      // if(randomIndex==0)
      // {
      //   this.fx_absorbtionTweenStar[i].time = speedStars/4;
      // }
      // this.fx_absorbtionTween[i].delay =  this.fx_absorbtionTween[i].time*(i*maxFxCount);
      // console.log(this.fx_absorbtionTweenStar[i].delay)
      this.fx_absorbtionTweenStar[i].easing = PIXI.tween.Easing.outExpo();
      this.fx_absorbtionTweenStar[i].loop = false;

      //-
      // this.fx_absorbtionTweenStar[i].loop = true;
      // this.fx_absorbtionTweenStar[i].delay = i/maxFxCountStars;
    }

    let animStartFrequency = 0.01; //(.01//1/maxFxCountStars);
    for (let i = 0; i < this.fx_absorbtionTweenStar.length; i++) {
      if (i < this.fx_absorbtionTweenStar.length - 1) {
        this.fx_absorbtionTweenStar[i].on(
          "update",
          function(tween: PIXI.tween.Tween, elapsedTime: number) {
            if (elapsedTime > animStartFrequency) {
              tween.start();
            }
          }.bind(
            this.fx_absorbtionTweenStar[i],
            this.fx_absorbtionTweenStar[i + 1]
          )
        );
      }

      let lastAnim = this.fx_absorbtionTweenStar.length - 1;
      this.fx_absorbtionTweenStar[lastAnim].on(
        "update",
        function(tween: PIXI.tween.Tween, elapsedTime: number) {
          if (elapsedTime > animStartFrequency) {
            tween.start();
          }
          3;
        }.bind(
          this.fx_absorbtionTweenStar[lastAnim],
          this.fx_absorbtionTweenStar[0]
        )
      );
    }
  };

  public setGlowScale = (newScale: number): void => {
    this.glowL.scale.set(newScale);
    this.glowR.scale.set(newScale);
  };
  public getGlowScale = (): number => {
    return this.glowL.scale.x;
  };
}
